import getCurrentPackage from './current-package';
import type { RootState } from '../types/store';
import messenger from '../messenger';
import type { HostingPackageProperties } from '../types/hosting-package';

function getCurrentPackageProperties(state: RootState): HostingPackageProperties | undefined {
  const currentPackage = getCurrentPackage(state);

  if (!currentPackage) throw new Error(messenger.missingData('currentPackage'));

  return currentPackage.properties;
}

export default getCurrentPackageProperties;
